export enum GoAntennaHeightUnitType {
    Feet = 'FT',
    Meters = 'M',
}

export const GoAntennaHeightUnitTypeToLabelMapping = {
    [GoAntennaHeightUnitType.Feet]: 'F',
    [GoAntennaHeightUnitType.Meters]: 'M',
};

export const GoAntennaHeightUnitTypeToExpandedLabelMapping = {
    [GoAntennaHeightUnitType.Feet]: 'feet',
    [GoAntennaHeightUnitType.Meters]: 'meters',
};
